import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { FirebaseStorage } from '@/services'

export const UploadFileToFirebase = async (image: File, path: string): Promise<null | string> => {
    const storageRef = ref(FirebaseStorage, path + Date.now().toString() + '-' + image.name)
    const { metadata, ref: fileRef } = await uploadBytes(storageRef, image)

    if (metadata && fileRef) {
        const url = await getDownloadURL(storageRef)

        if (typeof url === 'string' && url) return url
        else return null
    }

    else return null
}
